import type { StatsData } from '../../../types';

interface Props {
  stats: StatsData;
  loading: boolean;
}

function formatAmount(val: number): string {
  if (val >= 10000) return `¥${(val / 10000).toFixed(1)}万`;
  return `¥${val.toLocaleString('zh-CN')}`;
}

export default function OrderStats({ stats, loading }: Props) {
  const cards = [
    {
      label: '全部订单',
      value: loading ? '-' : String(stats.total),
      icon: 'ri-file-list-3-line',
      color: 'text-teal-600',
      bg: 'bg-teal-50',
    },
    {
      label: '未执行',
      value: loading ? '-' : String(stats.pending),
      icon: 'ri-time-line',
      color: 'text-amber-600',
      bg: 'bg-amber-50',
    },
    {
      label: '执行中',
      value: loading ? '-' : String(stats.inProgress),
      icon: 'ri-loader-4-line',
      color: 'text-cyan-600',
      bg: 'bg-cyan-50',
    },
    {
      label: '已完成',
      value: loading ? '-' : String(stats.completed),
      icon: 'ri-checkbox-circle-line',
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
    },
    {
      label: '订单总额',
      value: loading ? '-' : formatAmount(stats.totalAmount),
      icon: 'ri-money-cny-circle-line',
      color: 'text-teal-600',
      bg: 'bg-teal-50',
    },
    {
      label: '已收款',
      value: loading ? '-' : formatAmount(stats.paidAmount),
      icon: 'ri-secure-payment-line',
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
    },
    {
      label: '待收款',
      value: loading ? '-' : formatAmount(stats.pendingAmount),
      icon: 'ri-hand-coin-line',
      color: 'text-orange-600',
      bg: 'bg-orange-50',
      highlight: !loading && stats.pendingAmount > 0,
    },
    {
      label: '总支出',
      value: loading ? '-' : formatAmount(stats.totalExpense),
      icon: 'ri-arrow-up-circle-line',
      color: 'text-rose-500',
      bg: 'bg-rose-50',
      isExpense: true,
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2.5 md:gap-3">
      {cards.map(card => (
        <div key={card.label} className={`bg-white border rounded-xl p-3 md:p-4 transition-colors ${
          'highlight' in card && card.highlight
            ? 'border-orange-200 bg-orange-50/30'
            : 'isExpense' in card && card.isExpense
              ? 'border-rose-100'
              : 'border-gray-100'
        }`}>
          <div className="flex items-center gap-2 mb-2">
            <div className={`w-7 h-7 flex items-center justify-center rounded-lg ${card.bg}`}>
              <i className={`${card.icon} text-sm ${card.color}`} />
            </div>
          </div>
          <p className={`text-base md:text-xl font-bold leading-none mb-1 truncate ${
            'isExpense' in card && card.isExpense
              ? 'text-rose-500'
              : 'highlight' in card && card.highlight
                ? 'text-orange-600'
                : loading
                  ? 'text-gray-300'
                  : 'text-gray-900'
          }`}>
            {card.value}
          </p>
          <p className={`text-xs truncate ${
            'isExpense' in card && card.isExpense
              ? 'text-rose-300'
              : 'highlight' in card && card.highlight
                ? 'text-orange-400'
                : 'text-gray-400'
          }`}>{card.label}</p>
        </div>
      ))}
    </div>
  );
}
